import { Entry } from '../Entry'

export function Entry20221214() {
  return (
    <Entry title="14/12/2022 - v3.3.0">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/13524/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
